import SharedConstants from "@lib/shared_constants";

export const offerfitAppGroupIdUseCases = "/offerfit/:app_group_id/use_cases";

/**
 * Decisioning Studio agent tiers surfaced on digest items as `tier`.
 * Values are shared with the backend through `shared_constants.json`.
 */
export const decisioningStudioTiers = SharedConstants.DECISIONING_STUDIO.TIERS;
